import Cookies from 'js-cookie';

export default (
    $wire,
    { eventName, contactModal, visitorIdCookieName, initialPhoneNumberCtaText = '', payload = null },
) => ({
    data: null,
    medium: null,
    callTrackingEnabled: false,
    canShowPhoneModal: undefined,
    source: $wire.get('source'),
    googleSource: $wire.get('googleSource'),
    trackedPhoneNumber: $wire.get('trackedPhoneNumber'),
    renderContextForPhoneNumberTracking: $wire.entangle('renderContextForPhoneNumberTracking').live,
    trackedPhoneNumberAcquisitionSuccess: $wire.entangle('trackedPhoneNumberAcquisitionSuccess').live,
    trackedPhoneNumberAcquisitionRequested: $wire.entangle('trackedPhoneNumberAcquisitionRequested').live,

    init: async function () {
        if (payload) {
            this.data = payload;
        } else if (typeof $wire.getTriggerEnquiryModalEventData === 'function') {
            this.data = await $wire.getTriggerEnquiryModalEventData();
        } else {
            this.data = null;
        }
        const callTrackingSetting = this.data['callTrackingEnabled'];

        if (typeof callTrackingSetting !== 'undefined' && callTrackingSetting === true) {
            this.callTrackingEnabled = true;
        }

        this.canShowPhoneModal = !this.callTrackingEnabled;

        Alpine.effect(() => {
            if (
                this.renderContextForPhoneNumberTracking === this.data['render_context'] &&
                this.trackedPhoneNumberAcquisitionRequested === true
            ) {
                if (this.trackedPhoneNumberAcquisitionSuccess === false) {
                    this.openModal();
                }
            }
        });
    },

    get displayablePhoneNumberOnCta() {
        return this.trackedPhoneNumber ?? initialPhoneNumberCtaText;
    },

    get showPhoneModal() {
        return (
            this.canShowPhoneModal === true ||
            (this.trackedPhoneNumberAcquisitionRequested === true &&
                this.trackedPhoneNumberAcquisitionSuccess === false)
        );
    },

    wantsToEnquireUsing: function (medium, source = null, initiateCallToNumber = null) {
        if (initiateCallToNumber) {
            $wire.dispatchSelf('phoneCallInitiated', [initiateCallToNumber]);

            window.location.href = `tel:${initiateCallToNumber}`;
        }

        this.medium = medium;

        this.source = this.source ?? source;

        const visitorId = Cookies.get(visitorIdCookieName);

        if (typeof visitorId !== 'undefined') {
            this.data['visitor_id'] = visitorId;
        }

        this.data['source'] = this.source;

        if (this.callTrackingEnabled === true && this.medium === 'phone') {
            $wire.dispatchSelf('needsTrackedPhoneNumber', [this.data]);
        }

        if (this.medium === 'phone') {
            $wire.dispatch('trackShowPhoneNumberStart', { data: this.data });
        }

        if (this.medium === 'email') {
            $wire.dispatch('trackEmailEnquiryStart', { data: this.data });
        }

        if (this.medium !== 'phone' || this.showPhoneModal === true) {
            this.openModal();
        }
    },

    openModal: function () {
        this.data['type'] = this.medium;
        this.data['source'] = this.source;
        this.data['googleSource'] = this.googleSource;
        $wire.dispatchTo(contactModal, eventName, { data: this.data });
    },

    getMobileTrackPhoneNumber: async function (listingId, ga4Currency, data) {
        const ga4Item = await $wire.getGa4Item();
        $wire.getMobileTrackPhoneNumber(listingId, ga4Currency, ga4Item, data);
    },

    trackOpenPhoneNumberLink: async function (agencyPhoneNumber, modelId, ga4Currency, data) {
        const ga4Item = await $wire.getGa4Item();
        $wire.dispatch('trackOpenPhoneNumberLink', {
            agencyPhoneNumber,
            modelId,
            ga4Currency,
            ga4Item: JSON.stringify(ga4Item),
            data,
        });
    },
});
